import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import {colors, sizes, CustomPropTypes} from '../../../constants';
import Avatar from '../../avatar/Avatar';
import Icon from '../../icon/Icon';
import Message from '../../message/Message';

import styles from './FriendStatus.pcss';

class FriendStatus extends PureComponent {
    static propTypes = {
        avatar: PropTypes.string,
        ctaText: PropTypes.string,
        icon: CustomPropTypes.icon,
        id: PropTypes.string,
        onClick: PropTypes.func,
        placeholder: PropTypes.bool,
        name: PropTypes.string,
        presence: PropTypes.string,
        status: PropTypes.string
    };

    static defaultProps = {
        placeholder: false
    };

    onClick = () => {
        const {id, onClick} = this.props;

        if (onClick) {
            onClick(id);
        }
    };

    render() {
        const {avatar, ctaText, name, icon, placeholder, presence, status} = this.props;

        const buttonClasses = cx(styles.button, {
            [styles.buttonActive]: !placeholder,
            [styles.placeholder]: placeholder
        });

        return (
            <button className={buttonClasses} onClick={this.onClick}>
                <span className={cx(styles.placeholderAsset, styles.asset)}>
                    {name && (
                        <Avatar
                            avatar={avatar}
                            displayName={name}
                            presence={presence}
                            backgroundColor={colors.BLUE}
                        />
                    )}
                </span>

                <span className={styles.textWrapper}>
                    <span className={cx(styles.placeholderContent, styles.primaryText)}>
                        {name}
                    </span>
                    <span className={cx(styles.placeholderContent, styles.secondaryText)}>
                        {status && <Message code={status} />}
                    </span>
                </span>

                <span className={styles.iconWrapper}>
                    {icon && <Icon icon={icon} size={sizes.XSMALL} />}
                </span>

                {ctaText && !placeholder && (
                    <Message
                        className={styles.ctaTextWrapper}
                        code={`diesel.common.friend_status.btn.${ctaText}`}
                    />
                )}
            </button>
        );
    }
}

export default FriendStatus;
